import { Outlet } from "react-router-dom";

const Payees = () => <Outlet />;

export default Payees;
